









import Vue from 'vue'
import { oneOf } from '@/utils/helper'

export default Vue.extend({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    name: {
      type: String,
      default: 'radio-group'
    },
    id: {
      type: [Number, String],
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    checked: {
      type: [Number, String],
      default: null
    },
    outputType: {
      type: String,
      default: 'string',
      validator: oneOf(['string', 'number'])
    }
  },
  methods: {
    handleChange(e: { target: { value: string } }) {
      const value = e.target.value
      this.$emit('change', this.outputType === 'number' ? this.numerify(value) : value)
    },
    stringify(val: number | null): string | null {
      return val === null ? null : String(val)
    },
    numerify(val: string | null): number | null {
      return val === null ? null : Number(val)
    }
  }
})
